

(() => {
  if (window.__lhGallerySequentialPreload) return;
  window.__lhGallerySequentialPreload = true;

  const preloadGallery = (gallery) => {
    if (!gallery || gallery.dataset.lhPreloadReady === 'true') return;
    gallery.dataset.lhPreloadReady = 'true';

    const urls = [...gallery.querySelectorAll('[data-lh-gallery-thumb]')]
      .map((thumb) => thumb.dataset.lhGallerySrc)
      .filter(Boolean);
    if (urls.length < 2) return;
    const cache = [];
    gallery._lhPreloadedImages = cache;

    // Image 2 is already requested by the Liquid preload. Start two workers at
    // image 3 so the next clicks are warm without competing at high priority
    // with the visible LCP image.
    let nextIndex = 2;
    const preloadNext = () => {
      if (nextIndex >= urls.length) return;
      const url = urls[nextIndex];
      nextIndex += 1;
      const image = new Image();
      image.decoding = 'async';
      image.fetchPriority = 'low';
      cache.push(image);
      const continueQueue = () => {
        preloadNext();
      };
      image.onload = continueQueue;
      image.onerror = continueQueue;
      image.src = url;
    };

    preloadNext();
    preloadNext();
  };

  const init = (scope = document) => {
    scope.querySelectorAll('[data-lh-gallery]').forEach(preloadGallery);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();(() => {
  const rootUrl = () => window.Shopify?.routes?.root || '/';
  let notificationTimer;

  function formatMoney(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'USD',
        maximumFractionDigits: 2,
      }).format(Number(cents) / 100);
    } catch (_) {
      return '$' + (Number(cents) / 100).toFixed(2);
    }
  }

  function updateCartCount(count) {
    const cartIcon = document.querySelector('cart-icon');
    if (cartIcon && typeof cartIcon.renderCartBubble === 'function') {
      cartIcon.renderCartBubble(count);
      return;
    }
    const bubble = document.querySelector('[ref="cartBubble"]');
    const bubbleCount = document.querySelector('[ref="cartBubbleCount"]');
    if (bubbleCount) {
      bubbleCount.textContent = count < 100 ? String(count) : '';
      bubbleCount.classList.toggle('hidden', count === 0);
    }
    bubble?.classList.toggle('visually-hidden', count === 0);
  }

  function showNotification(message, count) {
    const notification = document.querySelector('[data-lh-cart-notification]');
    if (!notification) return;
    const copy = notification.querySelector('[data-lh-notification-text]');
    const countNode = notification.querySelector('[data-lh-notification-link] span');
    if (copy) copy.textContent = message;
    if (countNode) countNode.textContent = count;
    notification.classList.add('is-visible');
    notification.setAttribute('aria-hidden', 'false');
    clearTimeout(notificationTimer);
    notificationTimer = window.setTimeout(() => {
      notification.classList.remove('is-visible');
      notification.setAttribute('aria-hidden', 'true');
    }, 4400);
  }

  async function addToCart(form) {
    const submit = form.querySelector('[type="submit"]');
    if (submit?.disabled) return;
    submit?.setAttribute('aria-busy', 'true');
    if (submit) submit.disabled = true;
    try {
      const selectedAddons = [...(form.closest('[data-lh-product-root]')?.querySelectorAll('[data-lh-addon]:checked') || [])];
      const formData = new FormData(form);
      const response = await fetch(rootUrl() + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData,
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || 'This item could not be added.');

      const addonItems = selectedAddons
        .map((addon) => Number(addon.dataset.variantId || 0))
        .filter(Boolean)
        .map((id) => ({ id, quantity: 1 }));
      if (addonItems.length) {
        const addonResponse = await fetch(rootUrl() + 'cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: addonItems }),
        });
        const addonData = await addonResponse.json();
        if (!addonResponse.ok) throw new Error(addonData.description || 'The add-on items could not be added.');
      }

      const cartResponse = await fetch(rootUrl() + 'cart.js', { headers: { Accept: 'application/json' } });
      const cart = await cartResponse.json();
      updateCartCount(cart.item_count || 0);
      const addedCount = 1 + addonItems.length;
      showNotification(addedCount > 1 ? addedCount + ' items were added to your bag.' : (data.product_title || data.title || 'Item') + ' was added to your bag.', cart.item_count || 0);
    } catch (error) {
      showNotification(error.message || 'This item could not be added.', '');
    } finally {
      submit?.removeAttribute('aria-busy');
      if (submit) submit.disabled = false;
    }
  }

  function initProduct(root) {
    if (root.dataset.lhInitialized === 'true') return;
    root.dataset.lhInitialized = 'true';
    const form = root.querySelector('[data-aloha-add-form]');
    const variantsNode = root.querySelector('[data-lh-variants]');
    const idInput = root.querySelector('[data-lh-variant-id]');
    const price = root.querySelector('[data-lh-price]');
    const addLabel = root.querySelector('[data-lh-add-label]');
    const addButton = root.querySelector('[data-lh-add-button]');
    const stock = root.querySelector('[data-lh-stock]');
    const selectionPrice = root.querySelector('[data-lh-selection-price]');
    const selectionOption = root.querySelector('[data-lh-selection-option]');
    const selectionImage = root.querySelector('[data-lh-selection-image]');
    const sku = root.querySelector('[data-lh-sku]');
    const total = root.querySelector('[data-lh-total]');
    const sticky = root.querySelector('[data-lh-sticky-cart]');
    const stickyPrice = root.querySelector('[data-lh-sticky-price]');
    const stickyOption = root.querySelector('[data-lh-sticky-option]');
    const stickySubmit = root.querySelector('[data-lh-sticky-submit]');
    const stickyOptions = root.querySelector('[data-lh-sticky-options]');
    const stickySheet = root.querySelector('[data-lh-sticky-sheet]');
    const stickySizeLabel = root.querySelector('[data-lh-sticky-size-label]');
    const stickySizeChoices = [...root.querySelectorAll('[data-lh-sticky-size-value]')];
    const galleryMain = root.querySelector('[data-lh-gallery-main], .lh-pb-stage__image');
    const galleryCurrent = root.querySelector('[data-lh-gallery-current]');
    const mobileCarousel = root.querySelector('[data-lh-mobile-carousel]');
    const mobileTrack = mobileCarousel?.querySelector('.lh-pb-mobile-carousel__track');
    const mobileSlides = [...(mobileCarousel?.querySelectorAll('[data-lh-mobile-slide]') || [])];
    const mobileCurrent = root.querySelector('[data-lh-mobile-current]');
    const galleryThumbs = [...root.querySelectorAll('[data-lh-gallery-thumb]')];
    let variants = [];
    try { variants = JSON.parse(variantsNode?.textContent || '[]'); } catch (_) {}
    let currentVariant = variants.find((variant) => String(variant.id) === idInput?.value) || variants[0];

    function showGalleryImage(index, options = {}) {
      if (!galleryThumbs.length || !galleryMain) return;
      const safeIndex = (index + galleryThumbs.length) % galleryThumbs.length;
      const thumb = galleryThumbs[safeIndex];
      galleryMain.src = thumb.dataset.lhGallerySrc || galleryMain.src;
      galleryMain.alt = thumb.dataset.lhGalleryAlt || galleryMain.alt;
      galleryMain.removeAttribute('srcset');
      galleryThumbs.forEach((item, itemIndex) => {
        item.classList.toggle('is-active', itemIndex === safeIndex);
        item.setAttribute('aria-pressed', String(itemIndex === safeIndex));
      });
      if (galleryCurrent) galleryCurrent.textContent = String(safeIndex + 1);
      if (mobileCurrent) mobileCurrent.textContent = String(safeIndex + 1);
      if (options.scrollMobile !== false && mobileTrack && mobileSlides[safeIndex] && window.matchMedia('(max-width: 749px)').matches) {
        mobileTrack.scrollTo({ left: mobileSlides[safeIndex].offsetLeft, behavior: 'smooth' });
      }
    }

    root.querySelector('[data-lh-gallery-prev]')?.addEventListener('click', () => {
      const active = Math.max(0, galleryThumbs.findIndex((thumb) => thumb.classList.contains('is-active')));
      showGalleryImage(active - 1);
    });
    root.querySelector('[data-lh-gallery-next]')?.addEventListener('click', () => {
      const active = Math.max(0, galleryThumbs.findIndex((thumb) => thumb.classList.contains('is-active')));
      showGalleryImage(active + 1);
    });

    function updatePurchaseSummary() {
      if (!currentVariant) return;
      const quantityValue = Math.max(1, Number(root.querySelector('[data-lh-quantity]')?.value || 1));
      const addonTotal = [...root.querySelectorAll('[data-lh-addon]:checked')].reduce((sum, addon) => sum + Number(addon.dataset.price || 0), 0);
      const totalCents = Number(currentVariant.price || 0) * quantityValue + addonTotal;
      if (total) total.textContent = formatMoney(totalCents);
    }

    function selectVariant() {
      const selected = [...root.querySelectorAll('[data-lh-option-group]')].map((group) => {
        return group.querySelector('.is-active')?.dataset.lhOptionValue;
      });
      const variant = variants.find((item) => item.options.every((option, index) => option === selected[index]));
      if (!variant) return;
      currentVariant = variant;
      if (idInput) idInput.value = variant.id;
      const money = formatMoney(variant.price);
      if (price) price.textContent = money;
      if (selectionPrice) selectionPrice.textContent = money;
      if (selectionOption) selectionOption.textContent = variant.public_title || variant.title;
      if (sku) sku.textContent = variant.sku || '';
      if (stickyPrice) stickyPrice.textContent = money;
      if (stickyOption) stickyOption.textContent = variant.public_title || variant.title;
      if (stickySizeLabel) stickySizeLabel.textContent = variant.options?.[0] || variant.public_title || variant.title;
      stickySizeChoices.forEach((choice) => {
        const active = choice.dataset.lhStickySizeValue === variant.options?.[0];
        choice.classList.toggle('is-active', active);
        choice.setAttribute('aria-pressed', String(active));
      });
      if (addButton) addButton.disabled = !variant.available;
      if (stickySubmit) {
        stickySubmit.disabled = !variant.available;
        stickySubmit.textContent = variant.available ? 'Add to cart' : 'Sold out';
      }
      if (addLabel) addLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';
      if (stock) stock.textContent = variant.available
        ? 'Available to order. Processing: 2–4 business days. Transit: 5–7 business days. Estimated total: 7–11 business days.'
        : 'Currently unavailable.';
      const variantImage = variant.featured_image?.src;
      if (variantImage) {
        if (selectionImage) selectionImage.src = variantImage;
        if (galleryMain) {
          galleryMain.src = variantImage;
          galleryMain.removeAttribute('srcset');
        }
      }
      updatePurchaseSummary();
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }

    root.querySelectorAll('[data-lh-option-value]').forEach((button) => {
      button.addEventListener('click', () => {
        const group = button.closest('[data-lh-option-group]');
        group?.querySelectorAll('[data-lh-option-value]').forEach((item) => item.classList.remove('is-active'));
        group?.querySelectorAll('[data-lh-option-value]').forEach((item) => item.setAttribute('aria-pressed', 'false'));
        button.classList.add('is-active');
        button.setAttribute('aria-pressed', 'true');
        const label = root.querySelector('[data-lh-option-label="' + group?.dataset.lhOptionGroup + '"]');
        if (label) label.textContent = button.dataset.lhOptionValue || '';
        selectVariant();
      });
    });

    const quantity = root.querySelector('[data-lh-quantity]');
    root.querySelector('[data-lh-qty-minus]')?.addEventListener('click', () => {
      quantity.value = Math.max(1, Number(quantity.value || 1) - 1);
      updatePurchaseSummary();
    });
    root.querySelector('[data-lh-qty-plus]')?.addEventListener('click', () => {
      quantity.value = Number(quantity.value || 1) + 1;
      updatePurchaseSummary();
    });
    quantity?.addEventListener('change', updatePurchaseSummary);
    root.querySelectorAll('[data-lh-addon]').forEach((addon) => addon.addEventListener('change', updatePurchaseSummary));
    const openStickyOptions = () => {
      if (!stickySheet) return;
      stickySheet.classList.add('is-open');
      stickySheet.setAttribute('aria-hidden', 'false');
      stickyOptions?.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('lh-sticky-sheet-open');
      stickySheet.querySelector('.is-active, [data-lh-sticky-size-value]')?.focus();
    };

    const closeStickyOptions = () => {
      if (!stickySheet) return;
      stickySheet.classList.remove('is-open');
      stickySheet.setAttribute('aria-hidden', 'true');
      stickyOptions?.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('lh-sticky-sheet-open');
    };

    stickyOptions?.addEventListener('click', openStickyOptions);
    stickySheet?.querySelectorAll('[data-lh-sticky-sheet-close]').forEach((button) => button.addEventListener('click', closeStickyOptions));
    stickySizeChoices.forEach((choice) => {
      choice.addEventListener('click', () => {
        const value = choice.dataset.lhStickySizeValue;
        const mainChoice = [...root.querySelectorAll('[data-lh-option-value]')].find((button) => button.dataset.lhOptionValue === value);
        mainChoice?.click();
        closeStickyOptions();
        stickyOptions?.focus();
      });
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && stickySheet?.classList.contains('is-open')) closeStickyOptions();
    });

    stickySubmit?.addEventListener('click', () => form?.requestSubmit());
    updatePurchaseSummary();

  }

  function initCollection(section) {
    if (section.dataset.lhInitialized === 'true') return;
    section.dataset.lhInitialized = 'true';
    const drawer = section.querySelector('[data-lh-filter-drawer]');
    const open = () => {
      drawer?.classList.add('is-open');
      drawer?.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
    };
    const close = () => {
      drawer?.classList.remove('is-open');
      drawer?.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    };
    section.querySelector('[data-lh-filter-open]')?.addEventListener('click', open);
    section.querySelectorAll('[data-lh-filter-close]').forEach((button) => button.addEventListener('click', close));
    section.querySelector('[data-lh-sort]')?.addEventListener('change', (event) => event.target.form?.submit());
  }

  function initCart(section) {
    if (section.dataset.lhInitialized === 'true') return;
    section.dataset.lhInitialized = 'true';
    section.querySelectorAll('[data-lh-cart-quantity]').forEach((input) => {
      input.closest('.lh-cart-quantity')?.querySelector('[data-lh-cart-minus]')?.addEventListener('click', () => {
        input.value = Math.max(0, Number(input.value || 0) - 1);
      });
      input.closest('.lh-cart-quantity')?.querySelector('[data-lh-cart-plus]')?.addEventListener('click', () => {
        input.value = Number(input.value || 0) + 1;
      });
    });
  }

  function init(scope = document) {
    scope.querySelectorAll('[data-lh-product-root]').forEach(initProduct);
    scope.querySelectorAll('.lh-collection').forEach(initCollection);
    scope.querySelectorAll('.lh-cart-page').forEach(initCart);
  }

  document.addEventListener('submit', (event) => {
    const form = event.target.closest?.('[data-aloha-add-form]');
    if (!form) return;
    event.preventDefault();
    addToCart(form);
  });
  document.addEventListener('click', (event) => {
    const thumbnail = event.target.closest?.('[data-lh-gallery-thumb]');
    if (thumbnail) {
      event.preventDefault();
      const gallery = thumbnail.closest('[data-lh-gallery]');
      const main = gallery?.querySelector('[data-lh-gallery-main], .lh-pb-stage__image');
      if (main) {
        main.src = thumbnail.dataset.lhGallerySrc || main.src;
        main.alt = thumbnail.dataset.lhGalleryAlt || main.alt;
        main.removeAttribute('srcset');
        const thumbs = [...gallery.querySelectorAll('[data-lh-gallery-thumb]')];
        const index = thumbs.indexOf(thumbnail);
        thumbs.forEach((item, itemIndex) => {
          item.classList.toggle('is-active', itemIndex === index);
          item.setAttribute('aria-pressed', String(itemIndex === index));
        });
        const count = gallery.querySelector('[data-lh-gallery-current]');
        if (count && index >= 0) count.textContent = String(index + 1);
      }
      return;
    }
    if (event.target.closest?.('[data-lh-notification-close]')) {
      const notification = document.querySelector('[data-lh-cart-notification]');
      notification?.classList.remove('is-visible');
      notification?.setAttribute('aria-hidden', 'true');
    }
  });
  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

(() => {
  if (window.__lhPdpConversionLoaded) return;
  window.__lhPdpConversionLoaded = true;

  function initPdpConversion(root = document) {
    const scopedPdp = root.matches?.('.lh-pb-pdp') ? root : root.querySelector?.('.lh-pb-pdp');
    const pdp = scopedPdp || document.querySelector('.lh-pb-pdp');
    if (!pdp || pdp.dataset.lhConversionReady) return;
    pdp.dataset.lhConversionReady = 'true';

    const sticky = pdp.querySelector('.lh-sticky-cart');
    const primaryButton = pdp.querySelector('[data-lh-add-button]');
    if (sticky && primaryButton) {
      sticky.classList.add('lh-sticky-cart--enhanced');
      sticky.setAttribute('aria-hidden', 'true');

      const updateSticky = () => {
        const rect = primaryButton.getBoundingClientRect();
        const primaryVisible = rect.top < window.innerHeight && rect.bottom > 0;
        const shouldShow = window.scrollY > 240 && !primaryVisible;
        sticky.classList.toggle('is-visible', shouldShow);
        sticky.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      };

      updateSticky();
      window.addEventListener('scroll', updateSticky, { passive: true });
      window.addEventListener('resize', updateSticky, { passive: true });
    }

    const sizeGroup = [...pdp.querySelectorAll('fieldset')].find((fieldset) =>
      fieldset.querySelector('legend')?.textContent.trim().startsWith('Size:')
    );
    if (sizeGroup && !pdp.querySelector('.lh-pdp-size-note')) {
      const note = document.createElement('p');
      note.className = 'lh-pdp-size-note';
      note.textContent = 'Sizing tip: check the shirt measurements and choose the fit you prefer.';
      sizeGroup.insertAdjacentElement('afterend', note);
    }

    const relatedSections = [...pdp.querySelectorAll('.lh-pb-related:not(.lh-pb-related--similar)')];
    relatedSections.forEach((section) => {
      const heading = section.querySelector('h2');
      if (heading) heading.textContent = 'More Hawaiian shirt prints';
      if (!section.querySelector('.lh-pb-related__intro')) {
        const intro = document.createElement('p');
        intro.className = 'lh-pb-related__intro';
        intro.textContent = 'Add another Hawaiian shirt print to your order. U.S. shipping is free with two or more shirts.';
        const grid = section.querySelector('.lh-product-grid');
        grid ? section.insertBefore(intro, grid) : section.appendChild(intro);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initPdpConversion(), { once: true });
  } else {
    initPdpConversion();
  }

  document.addEventListener('shopify:section:load', (event) => initPdpConversion(event.target));
})();


(() => {
  if (window.__lhNativeCarouselSync) return;
  window.__lhNativeCarouselSync = true;
  const mobile = window.matchMedia('(max-width: 749px)');
  let scrollFrame = 0;

  const updateState = (gallery, index) => {
    const thumbs = [...gallery.querySelectorAll('[data-lh-gallery-thumb]')];
    const safeIndex = Math.max(0, Math.min(thumbs.length - 1, index));
    thumbs.forEach((thumb, thumbIndex) => {
      thumb.classList.toggle('is-active', thumbIndex === safeIndex);
      thumb.setAttribute('aria-pressed', String(thumbIndex === safeIndex));
    });
    const desktopCount = gallery.querySelector('[data-lh-gallery-current]');
    const mobileCount = gallery.querySelector('[data-lh-mobile-current]');
    if (desktopCount) desktopCount.textContent = String(safeIndex + 1);
    if (mobileCount) mobileCount.textContent = String(safeIndex + 1);
    const main = gallery.querySelector('[data-lh-gallery-main], .lh-pb-stage__image, .lh-pb-stage img');
    const thumb = thumbs[safeIndex];
    if (main && thumb) {
      main.src = thumb.dataset.lhGallerySrc || main.src;
      main.alt = thumb.dataset.lhGalleryAlt || main.alt;
      main.removeAttribute('srcset');
    }
  };

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : event.target?.parentElement;
    const thumb = target?.closest('[data-lh-gallery-thumb]');
    if (!thumb) return;
    const gallery = thumb.closest('[data-lh-gallery]');
    const track = gallery?.querySelector('.lh-pb-mobile-carousel__track');
    const thumbs = [...(gallery?.querySelectorAll('[data-lh-gallery-thumb]') || [])];
    const index = thumbs.indexOf(thumb);
    if (index < 0) return;

    if (!mobile.matches) {
      updateState(gallery, index);
      return;
    }

    if (!track) return;
    track.scrollTo({ left: index * track.clientWidth, behavior: 'smooth' });
    updateState(gallery, index);
  }, true);

  document.addEventListener('scroll', (event) => {
    const track = event.target instanceof Element ? event.target.closest('.lh-pb-mobile-carousel__track') : null;
    if (!track || !mobile.matches) return;
    cancelAnimationFrame(scrollFrame);
    scrollFrame = requestAnimationFrame(() => {
      const gallery = track.closest('[data-lh-gallery]');
      if (!gallery) return;
      const slideCount = track.querySelectorAll('[data-lh-mobile-slide]').length;
      const index = Math.max(0, Math.min(slideCount - 1, Math.round(track.scrollLeft / Math.max(1, track.clientWidth))));
      updateState(gallery, index);
    });
  }, true);
})();
